<mat-chip-listbox class="st-desk-value-container">
    <mat-chip *ngIf="value[0]"
              removable
              class="st-desk-value"
              [matTooltip]="getItemLabel(value[0])"
              matTooltipPosition="above"
              (removed)="remove(value[0])">
        {{getItemLabel(value[0])}}
    </mat-chip>
    <mat-chip *ngIf="value[1]"
              removable
              class="st-desk-value"
              [matTooltip]="getItemLabel(value[1])"
              matTooltipPosition="above"
              (removed)="remove(value[1])">
        {{getItemLabel(value[1])}}
    </mat-chip>
    <mat-chip *ngIf="value[2]"
              removable
              class="st-desk-value"
              [matTooltip]="getItemLabel(value[2])"
              matTooltipPosition="above"
              (removed)="remove(value[2])">
        {{getItemLabel(value[2])}}
    </mat-chip>
    <mat-chip *ngIf="value[3]"
              removable
              class="st-desk-value"
              [matTooltip]="getItemLabel(value[3])"
              matTooltipPosition="above"
              (removed)="remove(value[3])">
        {{getItemLabel(value[3])}}
    </mat-chip>
    <mat-chip *ngIf="value[4]"
              removable
              class="st-desk-value"
              [matTooltip]="getItemLabel(value[4])"
              matTooltipPosition="above"
              (removed)="remove(value[4])">
        {{getItemLabel(value[4])}}
    </mat-chip>
    <mat-chip *ngIf="value[5]"
              removable
              class="st-desk-value"
              [matTooltip]="getItemLabel(value[5])"
              matTooltipPosition="above"
              (removed)="remove(value[5])">
        {{getItemLabel(value[5])}}
    </mat-chip>
</mat-chip-listbox>

<button mat-button
        #trigger
        class="st-desk-button-add"
        (menuClosed)="valueChanged()"
        (menuOpened)="onMenuOpened()"
        [disabled]="disabled"
        [matMenuTriggerFor]="listDropDownMenu"
        [class.st-desk-button-add-valid]="(required && value && value?.length === 0) || !value"
        [class.st-desk-button-add-required]="required">
    <mat-icon>
        add
    </mat-icon>
    {{label}}
</button>

<mat-menu #listDropDownMenu="matMenu"
          class="st-desk-menu">
    <mat-chip-grid #chipGrid
                   click-stop-propagation>
        <mat-chip-row *ngFor="let item of value"
                      (removed)="remove(item)">
            {{getItemLabel(item)}}
            <button matChipRemove>
                <mat-icon>close</mat-icon>
            </button>
        </mat-chip-row>
    </mat-chip-grid>
    <form click-stop-propagation [dir]="dir">
        <mat-form-field subscriptSizing="dynamic"
                        appearance="fill"
                        class="st-desk-form-field">
            <mat-icon matPrefix>search</mat-icon>
            <input type="text"
                   #searchBox
                   matInput
                   [matChipInputFor]="chipGrid"
                   [placeholder]="appService.languageSettings.PSTWebSearchLabel"
                   [formControl]="deskFilter"
                   (matChipInputTokenEnd)="add($event)">
        </mat-form-field>
        <mat-selection-list [ngModel]="value"
                            click-stop-propagation
                            (selectionChange)="selected($event)"
                            [multiple]="false"
                            hideSingleSelectionIndicator>
            <mat-list-option *ngFor="let item of filteredOptions | async"
                            [disabled]="!item.selectable"
                             [value]="item.id"
                             class="st-desk-list-option">
                {{item.title}}
                <mat-icon class="st-desk-list-option-icon">add</mat-icon>
            </mat-list-option>
        </mat-selection-list>
    </form>
</mat-menu>
